import { render, staticRenderFns } from "./RegiaoUfForm.vue?vue&type=template&id=9db17930"
import script from "./RegiaoUfForm.vue?vue&type=script&lang=js"
export * from "./RegiaoUfForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports